// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactPage_container__13COK","formTitle":"ContactPage_formTitle__1LP56","link":"ContactPage_link__3mvpY"};